// extracted by mini-css-extract-plugin
export var highlight = "MarkedTitle-module--highlight--9c627";
export var highlightVisible = "MarkedTitle-module--highlightVisible--df8c7";
export var marker = "MarkedTitle-module--marker--d4e00";
export var markerAbove = "MarkedTitle-module--markerAbove--88a60";
export var markerOverlay = "MarkedTitle-module--markerOverlay--f4116";
export var markerUnderline = "MarkedTitle-module--markerUnderline--f1bd2";
export var program = "MarkedTitle-module--program--6fdf2";
export var root = "MarkedTitle-module--root--aacaa";
export var speakers = "MarkedTitle-module--speakers--c2199";
export var topics = "MarkedTitle-module--topics--17d72";